import { render, staticRenderFns } from "./TcmPrintTreatmentRecord.vue?vue&type=template&id=21f7bdfc&"
import script from "./TcmPrintTreatmentRecord.vue?vue&type=script&lang=js&"
export * from "./TcmPrintTreatmentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports